import { Button } from "@material-tailwind/react";
import { Edit } from "lucide-react";
import React from "react";

const PreviewConfirmation = ({
  formData,
  customers,
  property,
  setActiveStep,
}) => {
  const formatNumber = (number) => {
    return parseFloat(number || 0).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      const dateObj = new Date(date);
      return dateObj.toLocaleDateString();
    } catch (e) {
      return "N/A";
    }
  };

  return (
    <>
      <div className="bg-white rounded-xl overflow-y-auto max-h-[75vh] p-2">
        <h2 className="font-semibold text-slate-800 mb-6">
          Review Sale Details
        </h2>

        {/* Property & Customer Card */}
        <div className="mb-6 border rounded-lg p-4">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-medium text-lg">Property & Customer Details</h3>
            <Button
              size="sm"
              variant="outline"
              onClick={() => setActiveStep(0)}
              color="black"
              className="px-2 py-1"
            >
              <Edit size={20} />
            </Button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <p className="text-sm text-slate-600 mb-1">Property Number</p>
              <p className="font-medium">{property?.propertyNo || "N/A"}</p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">Customer Name</p>
              <p className="font-medium">
                {customers.find(c => c.userId === parseInt(formData.customerId))?.firstName || "N/A"}{" "}
                {customers.find(c => c.userId === parseInt(formData.customerId))?.lastName || ""}
              </p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">Project Name</p>
              <p className="font-medium">{property?.projectPhase?.project?.projectName || "N/A"}</p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">Customer Email</p>
              <p className="font-medium">
                {customers.find(c => c.userId === parseInt(formData.customerId))?.emailId || "N/A"}
              </p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">Customer Phone</p>
              <p className="font-medium">
                {customers.find(c => c.userId === parseInt(formData.customerId))?.phoneNumber || "N/A"}
              </p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">Property Type</p>
              <p className="font-medium">{property?.propertyType || "N/A"}</p>
            </div>
          </div>
        </div>

        {/* Sale Details Card */}
        <div className="mb-6 border rounded-lg p-4">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-medium text-lg">Sale Details</h3>
            <Button
              size="sm"
              variant="outline"
              onClick={() => setActiveStep(1)}
              color="black"
              className="px-2 py-1"
            >
              <Edit size={20} />
            </Button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <p className="text-sm text-slate-600 mb-1">Sale Date</p>
              <p className="font-medium">{formatDate(formData.saleDate)}</p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">Agreement Value</p>
              <p className="font-medium">₹{formatNumber(formData.basePrice)} </p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">Payment Option</p>
              <p className="font-medium capitalize">{formData.paymentOption || "N/A"}</p>
            </div>
           
          </div>
        </div>

        {/* Government Charges Card */}
        <div className="mb-6 border rounded-lg p-4">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-medium text-lg">Government Charges</h3>
            <Button
              size="sm"
              variant="outline"
              onClick={() => setActiveStep(1)}
              color="black"
              className="px-2 py-1"
            >
              <Edit size={20} />
            </Button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <p className="text-sm text-slate-600 mb-1">Stamp Duty</p>
              <p className="font-medium">
              ₹{formatNumber(formData.stampDuty)} 
              </p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">GST</p>
              <p className="font-medium">
              ₹{formatNumber(formData.gst)} 
              </p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">Registration Price</p>
              <p className="font-medium">
              ₹{formatNumber(formData.registrationPrice)}
              </p>
            </div>
          </div>
        </div>

        {/* Bank Loan Details Card */}
        {formData.isBankLoanInvolved && (
          <div className="mb-6 border rounded-lg p-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-medium text-lg">Bank Loan Details</h3>
              <Button
                size="sm"
                variant="outline"
                onClick={() => setActiveStep(1)}
                color="black"
                className="px-2 py-1"
              >
                <Edit size={20} />
              </Button>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div>
                <p className="text-sm text-slate-600 mb-1">Bank Name</p>
                <p className="font-medium">{formData.bankName || "N/A"}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600 mb-1">Branch</p>
                <p className="font-medium">{formData.branch || "N/A"}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600 mb-1">Loan Amount</p>
                <p className="font-medium">₹{formatNumber(formData.loanAmount)} </p>
              </div>
              <div>
                <p className="text-sm text-slate-600 mb-1">Bank Email</p>
                <p className="font-medium">{formData.bankEmail || "N/A"}</p>
              </div>
            </div>
          </div>
        )}

        {/* Payment Details Card */}
        <div className="border rounded-lg p-4">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-medium text-lg">Payment Details</h3>
            <Button
              size="sm"
              variant="outline"
              onClick={() => setActiveStep(2)}
              color="black"
              className="px-2 py-1"
            >
              <Edit size={20} />
            </Button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <p className="text-sm text-slate-600 mb-1">Payment Type</p>
              <p className="font-medium capitalize">{formData.paymentType || "N/A"}</p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">Token Amount</p>
              <p className="font-medium">₹{formatNumber(formData.tokenTotalAmount)}</p>
            </div>
            <div>
              <p className="text-sm text-slate-600 mb-1">Down Payment</p>
              <p className="font-medium">₹{formatNumber(formData.downPaymentTotalAmount)} </p>
            </div>
          </div>

          {/* Scheduled Payment Table */}
          {formData.paymentPlan && formData.paymentPlan.length > 0 && (
            <div className="mt-6">
              <h4 className="font-medium mb-4">Payment Schedule</h4>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-slate-200">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase">Installment</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase">Amount</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase">Date</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase">Payment Source</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-slate-200">
                    {formData.paymentPlan.map((payment, index) => (
                      <tr key={index} className="hover:bg-slate-50">
                        <td className="px-4 py-3 whitespace-nowrap">
                          {index + 1}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap">
                        ₹{formatNumber(payment.projectedAmount)} 
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap">
                          {formatDate(payment.projectedDate)}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap">
                          <span className={`px-2 py-1 rounded-full text-xs ${
                            payment.paymentSource === "BANK" 
                              ? "bg-blue-100 text-blue-800" 
                              : payment.paymentSource === "SPLIT"
                              ? "bg-purple-100 text-purple-800"
                              : "bg-green-100 text-green-800"
                          }`}>
                            {payment.paymentSource || "USER"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="bg-slate-50">
                    <tr>
                      <td className="px-4 py-3 font-medium">Total</td>
                      <td className="px-4 py-3 font-medium">
                      ₹{formatNumber(formData.paymentPlan.reduce((sum, payment) => 
                          sum + (parseFloat(payment.projectedAmount) || 0), 0))}
                      </td>
                      <td colSpan="2"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PreviewConfirmation;
